import React, { Component } from "react";
import Form from "./Form/Form";
import Onboarding from "./Onboarding/Onboarding";
import "./SignUp.css";

class SignUp extends Component {
	render() {
		let step = this.props.onboardingStep;
		return (
			<div className="container">
				{step === 0 && (
					<Form
						trianglify={this.props.trianglify}
						onboardingStep={this.props.onboardingStep}
						onboardingFlow={this.props.onboardingFlow}
						nextOnboarding={this.props.nextOnboarding}
						signUpParams={this.props.signUpParams}
						onChangeInput={this.props.onChangeInput}
					/>
				)}
				{step > 0 && (
					<Onboarding
						searchProducts={this.props.searchProducts}
						signUpParams={this.props.signUpParams}
						onboardingStep={this.props.onboardingStep}
						onboardingFlow={this.props.onboardingFlow}
						addToOnboardingCart={this.props.addToOnboardingCart}
						getSignUpProductTotal={this.props.getSignUpProductTotal}
						nextOnboarding={this.props.nextOnboarding}
						backOnboarding={this.props.backOnboarding}
						onToken={this.props.onToken}
					/>
				)}
			</div>
		);
	}
}

export default SignUp;


// WEBPACK FOOTER //
// ./src/components/SignUp/SignUp.js